import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, renderSlot as _renderSlot, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Transition as _Transition, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-f45fa2f4"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "background" }, null, -1))
const _hoisted_2 = { class: "foreground" }
const _hoisted_3 = { class: "inner" }


export default /*#__PURE__*/_defineComponent({
  __name: 'ModalOverlay',
  props: {
    active: { type: Boolean }
  },
  setup(__props: any) {

const props = __props as {
    active: boolean
  };

  

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_Transition, { name: "fade" }, {
    default: _withCtx(() => [
      (__props.active)
        ? (_openBlock(), _createElementBlock("div", {
            key: 0,
            class: _normalizeClass(["modal-overlay", {'is-active': props.active}])
          }, [
            _hoisted_1,
            _createElementVNode("div", _hoisted_2, [
              _createElementVNode("div", _hoisted_3, [
                _renderSlot(_ctx.$slots, "default")
              ])
            ])
          ], 2))
        : _createCommentVNode("", true)
    ]),
    _: 3
  }))
}
}

})